/**
@format
@flow
*/
import * as React from 'react';
import Colors from '@ziynx/theme/colors';
import { SubHeading as KrispySubHeading } from '@krispy/typography/web';

type Props = $ReadOnly<{|
  /**
   * Large font size
   */
  large?: boolean,

  /**
   * Medium font size
   */
  medium?: boolean,

  /**
   * Small font size
   */
  small?: boolean,

  /**
   * Color for body text
   */
  color?: string,

  /**
   * Primitive types
   */
  primitive?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',

  /**
   * Text
   */
  children: any,
|}>;

/**
 * SubHeading component, smaller than Heading, bigger than Body
 */
const SubHeading = (props: Props): React$Node => {
  const { color, children, ...rest } = props;

  return <KrispySubHeading color={color} {...rest}>{children}</KrispySubHeading>;
};

SubHeading.defaultProps = {
  color: Colors.GrayVeryDark,
  primitive: 'h4',
};

export default SubHeading;
